import { apiClient } from '~/api/client';
import { CompanyAndAgent } from '~/components/connections/types';

type IndexParams = {
  nmls: string;
  companyLicense: string;
  company_type: 'seller' | 'buyer';
  period: Period;
};

type IndexResponse = {
  data: {
    agents: CompanyAndAgent[];
  };
};

export const show = async ({ nmls, companyLicense, ...params }: IndexParams) =>
  apiClient.get<IndexResponse>(`/loan_officers/${nmls}/realtor_companies/${companyLicense}`, {
    params,
  });
